import React from 'react';
import logo from '../image_dir/LOGO.png';

/*
 * HeroSection displays the top portion of the landing page.  It shows
 * the company logo alongside the headline and introductory copy.  All
 * text is taken verbatim from the supplied PDF and wrapped in
 * appropriate HTML semantics.  The styling lives in App.css.
 */

function HeroSection() {
  return (
    <>
      {/* 1. Heading Banner Section */}
      <section className="heading-banner">
        <div className="heading-banner__inner">
          <img
            src={logo}
            alt="Wisyguide logo"
            className="heading-banner__logo"
          />
          <div className="heading-banner__tagline">
            Il tuo nuovo esperto tecnico,
            <br />
            con la memoria dell’intera azienda.
          </div>
        </div>
      </section>

      {/* 2. Informations Section */}
      <section className="information-section">
        {/* Block 1 */}
        <div className="information-container">
          <h2 className="info-title">
            Macchinari sempre più complessi
            <br />
            ed assistenza clienti sempre più intricata?
          </h2>
          <p className="info-subtitle">
            C’è un nuovo strumento per supportare il tuo team!
          </p>
        </div>

        {/* Block 2 */}
        <div className="information-container">
          <p>
            <span className="info-text">
            <strong><span className="color-wisy">wisy</span>
            <span className="color-guide">guide</span> è un agente IA, specializzato
            nell'assistenza clienti per ogni tipo di macchinario
            ed integrato in una piattaforma specifica per il customer
            service.</strong>
            </span>
          </p>
          <p>
            Alleggerisce il carico del tuo team grazie alla conoscenza della
            documentazione aziendale, anche considerando precedenti soluzioni
            adottate ai problemi di altri clienti e prepara le risposte, il
            tutto integrato in una piattaforma per la completa gestione
            dell’assistenza clienti.
          </p>
        </div>

        {/* Block 3 */}
        <div className="information-container">
          <p>
            <strong>
              <span className="info-text">
              Ricorda ogni documento, ogni email, ogni guasto
              ed ogni soluzione.
              </span>
            </strong>
          </p>
          <p>
            Non servono più anni per formare un addetto esperto ma chiunque,
            con il supporto di Wisy, può attingere alle esperienze maturate
            dall'azienda per fornire una soluzione rapida ed efficace.
          </p>
        </div>



        {/* Block 4 */}
        <div className="information-container">
          <p>
            <strong>
              <span className="info-text">
              La tua privacy è importante! I tuoi dati sono al sicuro con 
               <span className="color-wisy"> wisy</span>
            <span className="color-guide">guide</span>.
              </span>
            </strong>
          </p>
          <p>
          I tuoi dati, le tue email e le conversazioni con la nostra piattaforma rimangono privati e non vengono usati per l'addestramento di nessun modello IA.
          </p>
        </div>
      </section>
    </>
  );
}

export default HeroSection;